import getBannerMsg from "app/tools/queries/getBannerMsg"
import { useQuery } from "blitz"
import { useCurrentUser } from "../hooks/useCurrentUser"

export const BannerNotification = () => {
  const currentUser = useCurrentUser()
  const isLoggedIn = !!currentUser

  const [bannerMsg, { error }] = useQuery(
    getBannerMsg,
    {},
    {
      enabled: isLoggedIn,
      suspense: false,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
    }
  )

  if (!isLoggedIn) return null

  if (error) {
    console.error("Banner query failed", error)
    return null
  }

  if (!bannerMsg) return null

  return (
    <div className="px-4 py-2 text-center font-semibold" style={{ backgroundColor: "#ffad41" }}>
      {bannerMsg}
    </div>
  )
}
